<template>
<transition name="appear-transition">
  <div v-show="isReady" class="home">
    <div class="pages-wrapper">
      <transition name="single-page-transition">
        <div v-show="activeSlide == 0" class="single-page">
          <div class="bg">
            <video :src="videoSource" id="video1" autoplay playsinline webkit-playsinline muted loop preload="none"></video>
          </div>
          <div class="content">
            <h1 v-html="content['scan_doc']"></h1>
          </div>
          <div class="fixed-content-wrapper">
            <div class="button-wrapper">
              <button v-html="content['continue']" class="main-button" @click="nextSlide"></button>
            </div>
            <div class="footer-links">

            </div>
          </div>
        </div>
      </transition>
      <transition name="single-page-transition">
        <div v-show="activeSlide == 1" class="single-page">
          <div class="bg">
            <video :src="videoSource2" id="video2" autoplay playsinline webkit-playsinline muted loop preload="none"></video>
          </div>
          <div class="overlay">
            <img src="@/assets/g.png" alt="">
          </div>
          <div class="content">
            <h1 v-html="content['extract']"></h1>
          </div>
          <div class="fixed-content-wrapper">
            <div class="carousel-wrapper">
              <div class="carousel-slide-holder">
                <div class="carousel-slide-content-no-bg">
                  <h3 v-html="content['worked']"></h3>
                  <p v-html="content['with_scanner']"></p>
                  <div class="raeting-person-wrapper">
                    <div class="raeting-person">
                    <div class="raeting-person-info">
                      <img v-if="langCode != 'zh'" src="@/assets/p2.png" alt="">
                      <img v-else src="@/assets/p4.png" alt="">
                      <span v-html="content['name1']"></span>
                    </div>
                    <img class="five-stars" src="@/assets/r5.png" alt="">
                  </div>
                  </div>
                </div>
              </div>
              <transition name="carousel-slide-transition">
                <div v-if="carouselSlide == 0" class="carousel-slide">
                <div class="carousel-slide-content">
                  <h2 v-html="content['loved']"></h2>
                </div>
                  <img class="carousel-bg" src="@/assets/leaves.png" alt="">
                </div>
              </transition>
              <transition name="carousel-slide-transition">
                <div v-if="carouselSlide == 1" class="carousel-slide">
                <div class="carousel-slide-content">
                  <h2 v-html="content['reviews']"></h2>
                  <div class="raeting">
                    <span>4.6</span>
                    <img src="@/assets/r4.png" alt="">
                  </div>
                </div>
                  <img class="carousel-bg" src="@/assets/leaves.png" alt="">
                </div>
              </transition>
              <transition name="carousel-slide-transition">
                <div v-if="carouselSlide == 2" class="carousel-slide">
                <div class="carousel-slide-content-no-bg">
                  <h3 v-html="content['best_scanner']"></h3>
                  <p v-html="content['found']"></p>
                  <div class="raeting-person-wrapper">
                    <div class="raeting-person">
                    <div class="raeting-person-info">
                      <img v-if="langCode != 'zh'" src="@/assets/p1.png" alt="">
                      <img v-else src="@/assets/p3.png" alt="">
                      <span v-html="content['name2']"></span>
                    </div>
                    <img class="five-stars" src="@/assets/r5.png" alt="">
                  </div>
                  </div>
                </div>
                </div>
              </transition>
              <transition name="carousel-slide-transition">
                <div v-if="carouselSlide == 3" class="carousel-slide">
                <div class="carousel-slide-content-no-bg">
                  <h3 v-html="content['worked']"></h3>
                  <p v-html="content['with_scanner']"></p>
                  <div class="raeting-person-wrapper">
                    <div class="raeting-person">
                    <div class="raeting-person-info">
                      <img v-if="langCode != 'zh'" src="@/assets/p2.png" alt="">
                      <img v-else src="@/assets/p4.png" alt="">
                      <span v-html="content['name1']"></span>
                    </div>
                    <img class="five-stars" src="@/assets/r5.png" alt="">
                  </div>
                  </div>
                </div>
                </div>
              </transition>
            </div>
            <div class="button-wrapper">
              <div  class="login-button" id="appleid-signin" data-color="white" data-border="false" data-type="sign-up" :locale="langCode == 'zh' ? 'zh_CN' : 'en_US'" data-border-radius="50"></div>
            </div>
            <div class="footer-links">
              <button @click="privacy" v-html="content['pp']"></button>
              <span v-html="content['and']"></span>
              <button @click="tos" v-html="content['tos']"></button>
            </div>
          </div>
        </div>
      </transition>
      <transition name="single-page-transition">
        <div v-show="activeSlide == 2" class="single-page">
          <div class="bg">
            <video :style="{'visibility':appsCarouselSlide == 0 ? 'unset':'hidden'}" :src="videoSource3" id="video3" autoplay playsinline webkit-playsinline muted loop preload="none"></video>
            <video :style="{'visibility':appsCarouselSlide == 1 ? 'unset':'hidden'}" :src="videoSource4" id="video4" autoplay playsinline webkit-playsinline muted loop preload="none"></video>
            <video :style="{'visibility':appsCarouselSlide == 2 ? 'unset':'hidden'}" :src="videoSource5" id="video5" autoplay playsinline webkit-playsinline muted loop preload="none"></video>
            <video :style="{'visibility':appsCarouselSlide == 3 ? 'unset':'hidden'}" :src="videoSource6" id="video6" autoplay playsinline webkit-playsinline muted loop preload="none"></video>
          </div>
          <div class="overlay">
            <img src="@/assets/g.png" alt="">
          </div>
          <div class="content">
            <h1 v-if="appsCarouselSlide == 0" v-html="content['use_sc']"></h1>
            <h1 v-if="appsCarouselSlide == 1" v-html="content['use_iv']"></h1>
            <h1 v-if="appsCarouselSlide == 2" v-html="content['use_cr']"></h1>
            <h1 v-if="appsCarouselSlide == 3" v-html="content['use_spn']"></h1>
            <div class="apps-wrapper">
                <img :class="{'active':appsCarouselSlide == 0}" src="@/assets/sc.png" alt="">
                <img :class="{'active':appsCarouselSlide == 1}" src="@/assets/iv.png" alt="">
                <img :class="{'active':appsCarouselSlide == 2}" src="@/assets/cr.png" alt="">
                <img v-if="!isChina" :class="{'active':appsCarouselSlide == 3}" src="@/assets/spn.png" alt="">
            </div>
          </div>
          <div class="fixed-content-wrapper">
            <div class="spinner-wrapper">
              <img v-if="!isChina" :style="{'transform':`rotate(${90*appsCarouselSlide}deg)`}" src="@/assets/spinner.png" alt="">
              <img v-else :style="{'transform':`rotate(${120*appsCarouselSlide}deg)`}" src="@/assets/spinner_cn.png" alt="">
            </div>
            <div class="button-wrapper">
              <p class="price-description" v-html="preparedPriceDescriptionText"></p>
              <div class="price-info">
                <span v-html="content['trial']" class="trial-info"></span>
                <span class="price">{{ actualPrice.zeroPrice }}</span>
              </div>
              <div class="r-price-info">
                <span v-html="preparedPriceLine" class="r-price"></span>
              </div>
              <div v-if="userCanPay" class="payment-button-wrapper">
                <button v-if="paymentReady" class="main-button" v-html="content['continue']" @click="startPayment"></button>
                <div v-else class="loading-wrapper">
                  <img class="loader" src="@/assets/loading.png" alt="">
                </div>
              </div>
              <div v-else class="payment-button-wrapper">
                <button class="main-button" @click="setupApplePayScreenOpen" v-html="content['continue']"></button>
              </div>
            </div>
            <div class="footer-links">
              <button @click="privacy" v-html="content['pp']"></button>
              <span v-html="content['and']"></span>
              <button @click="tos" v-html="content['tos']"></button>
            </div>
          </div>
        </div>
      </transition>
      <transition name="single-page-transition">
        <div v-show="activeSlide == 3" class="single-page">
          <div class="bg">
            <img src="@/assets/downloadBg.png" alt="">
          </div>
          <div class="overlay">
            <img src="@/assets/g.png" alt="">
          </div>
          <div class="content">
            <h1 v-html="content['successful']"></h1>
          </div>
          <div class="fixed-content-wrapper">
            <p class="download" v-html="content['your_account']"></p>
            <div class="button-wrapper">
              <button v-if="langCode != 'zh'" @click="download" class="download-button"><img src="@/assets/download.png" alt=""></button>
              <button v-else @click="download" class="download-button"><img src="@/assets/download_cn.png" alt=""></button>
            </div>
            <div class="footer-links">
            </div>
          </div>
        </div>
      </transition>
    </div>
    <transition name="add-apple-pay-transition">
      <div @click="setupApplePayScreenClose" v-if="setupApplePayScreenStatus" class="add-apple-pay-wrapper">
        <div @click.stop class="add-apple-pay-inner">
          <img src="@/assets/card.png" alt="">
          <h3 v-html="content['please_add_card']"></h3>
          <button v-if="applePayAdded" @click="setupApplePayScreenClose" v-html="content['done']" class="main-button"></button>
          <button v-else @click="setupApplePay" v-html="content['add_card']" class="main-button"></button>
        </div>
      </div>
    </transition>

    <transition name="add-apple-pay-transition">
      <div v-show="userHaveSubscription" class="add-apple-pay-wrapper">
        <div @click.stop class="add-apple-pay-inner">
          <img src="@/assets/premium.png" alt="">
          <h3 v-html="content['premium_premium']"></h3>
          <button @click="download" v-html="content['premium_download']" class="main-button"></button>
        </div>
      </div>
    </transition>


  </div>
</transition>
</template>

<script>
import dataManager from '@/managers/dataManager.js'
import contentManager from '@/managers/contentManager.js'
import parametersManager from '@/managers/parametersManager.js'

import vid1 from '@/assets/video/1.mp4'
import vid2 from '@/assets/video/2.mp4'
import vid3 from '@/assets/video/3.mp4'
import vid4 from '@/assets/video/4.mp4'
import vid5 from '@/assets/video/5.mp4'
import vid6 from '@/assets/video/6.mp4'

let countryCode = 'US'

export default {
  name: "home",
  data () {
    return {
      countryCode:'',
      isChina:parametersManager.is_china,
      langCode:parametersManager.user_language,
      content:contentManager.content,
      activeSlide:0,
      videoSource:vid1,
      videoSource2:vid2,
      videoSource3:vid3,
      videoSource4:vid4,
      videoSource5:vid5,
      videoSource6:vid6,
      intent:'',
      intentError:'',
      loginData:'',
      email:'',
      userToken:'',
      isLogged: false,
      products: [],
      paymentError:'',
      sub:'',
      paymentRequest:null,
      paymentReady:false,
      carouselSlide:0,
      appsCarouselSlide:0,
      userCanPay:true,
      setupApplePayScreenStatus:false,
      actualPrice:{
        country: "CL",
        currency: "CLP",
        price: "$9,200.00",
        price_id: "price_1JcXFKD0uxxZ4pIFBqmhd16Q",
        zeroPrice: "$0.00"
      },
      applePayAdded:false,
      isReady:false,
      userHaveSubscription:false
    }
  },
  computed:{
    preparedLastpageVideoSource(){
      switch (this.appsCarouselSlide){
        case 0:
          return this.videoSource3
        break;
        case 1:
          return this.videoSource4
        break;
        case 2:
          return this.videoSource5
        break;
        case 3:
          return this.videoSource6
        break;
      }
    },
    preparedPriceDescriptionText(){
      switch (this.appsCarouselSlide){
        case 0:
          return this.content['scan_edit']
        break;
        case 1:
          return this.content['create_as_many']
        break;
        case 2:
          return this.content['record_your']
        break;
        case 3:
          return this.content['protect_privacy']
        break;
      }
    },
    preparedPriceLine(){
      let buffer = this.content['price_line']
      buffer = buffer.replace('{price}', this.actualPrice.price)
      return buffer 
    }
  },
  methods:{
    privacy(){
      window.open('https://neosus.net/privacy-policy-page/')
    },
    tos(){
      window.open('https://neosus.net/terms-of-use/')
    },
    setupApplePayScreenOpen(){
        this.setupApplePayScreenStatus = true
    },
    setupApplePayScreenClose(){
        this.setupApplePayScreenStatus = false
        this.recheckPaymentAbility();
    },
    recheckPaymentAbility(){
      this.isReady = false
      setTimeout(() => {
        window.location.reload();
      }, 500);
    },
    setupApplePay(){
      this.applePayAdded = true
      window.location.href = "shoebox://url-scheme";   
    },
    download(){
      window.open('https://apps.apple.com/us/app/scanner-pdf-scan-document/id1314963982')
    },
    nextSlide(){
      this.activeSlide+=1;
      let that = this
      if(this.activeSlide == 1){
        setInterval(()=>{
          that.carouselSlide += 1
          if(that.carouselSlide == 4){
            that.carouselSlide = 0
          }
        }, 4000)
      }else if(this.activeSlide == 2){
        if(!that.isChina){
          setInterval(()=>{
            that.restartVideo()
            that.appsCarouselSlide += 1
            if(that.appsCarouselSlide == 4){
              that.appsCarouselSlide = 0
            }
          }, 4000)
        }else{
          setInterval(()=>{
            that.restartVideo()
            that.appsCarouselSlide += 1
            if(that.appsCarouselSlide == 3){
              that.appsCarouselSlide = 0
            }
          }, 4000)
        }
      }
    },
    restartVideo(){
      let videoEl3 = document.getElementById('video3')
      let videoEl4 = document.getElementById('video4')
      let videoEl5 = document.getElementById('video5')
      let videoEl6 = document.getElementById('video6')

      videoEl3.currentTime = 0;
      videoEl4.currentTime = 0;
      videoEl5.currentTime = 0;
      videoEl6.currentTime = 0;
    },
    startPayment(){
      this.paymentRequest.show()
    }
  },
  mounted () {
    let videoEl3 = document.getElementById('video3')
    let videoEl4 = document.getElementById('video4')
    let videoEl5 = document.getElementById('video5')
    let videoEl6 = document.getElementById('video6')

    videoEl3.playbackRate = 2
    videoEl4.playbackRate = 2
    videoEl5.playbackRate = 2
    videoEl6.playbackRate = 2
    let that = this

    document.addEventListener('AppleIDSignInOnSuccess', (data) => {
      
      that.loginData = data.detail

      that.isLogged = true
      
      dataManager.createUser(that.loginData.authorization.id_token).then((res) => {
        that.userToken = res.data.token

          dataManager.getStatus(that.userToken).then((statusRes)=>{
            console.log(statusRes)
            if(statusRes.data.account_status == 'active'){
              that.userHaveSubscription = true
            }else{
              that.nextSlide()
              dataManager.createSubscription(that.userToken, 'name', that.actualPrice.price_id, that.products[0].id).then((subs)=>{
              that.sub = subs
              let stripe = parametersManager.is_staging ? Stripe('pk_test_51IYWiAD0uxxZ4pIFprbEPzuK6Mf5XxTwLzYTBKs3KCq7QJKzvvQY3c43nqwxAwVkNmcsgirf4iyT2NvlArQ7vpzn00O2zMSgOD') : Stripe('pk_live_51IYWiAD0uxxZ4pIFo0qdQcCPtjlPiDjRrCZDQzYgxamrCzAFpNMjXTBh6tv5c4Nby7B14QxQlH6R2Ie5UqXfTY8G007aVm5rbb')
              let paymentRequest = stripe.paymentRequest({
                currency:that.actualPrice.currency.toLowerCase(),
                country:'LT',
                requestPayerName: true,
                requestPayerEmail: true,
                total:{
                  label: 'Scanner PDF',
                  amount:0,
                }
              })
              that.paymentRequest = paymentRequest

              paymentRequest.canMakePayment().then((result)=>{
              if(result){
                that.paymentReady = true
              }else{
                that.paymentReady = true
                that.userCanPay = false
              }
              }).catch((error)=>{
              that.paymentReady = true
              that.userCanPay = false
            })

            paymentRequest.on('paymentmethod', async (e) => {
              dataManager.setPaymentId(that.userToken, that.sub.data.customer_id, e.paymentMethod.id).then((resp)=>{})
              let {error, paymentIntent} = await stripe.confirmCardSetup(that.sub.data.secret, { payment_method: e.paymentMethod.id }, {handleActions:false})
              if(error){
                e.complete('fail')
              }
              fbq('track', 'StartTrial');
              that.nextSlide()
              e.complete('success')
              if(paymentIntent.status === 'requires_action'){
                stripe.confirmCardSetup(that.sub.data.secret)
              }
            })
            })
            }
          })

      })
    });
    //Listen for authorization failures
    document.addEventListener('AppleIDSignInOnFailure', (error) => {
  });

  dataManager.getUserInformation().then((res)=>{
    eval(res.data);
    dataManager.getProducts().then((products)=>{
      that.countryCode = countryCode
      that.products = products
      let buffer = that.products[0].prices.find(
        price => price.country == countryCode
        ) || that.products[0].prices.find(
              price => price.country == "US"
            )
      buffer.zeroPrice = parametersManager.zeroPrice(buffer.price)
      that.actualPrice = buffer
      this.isReady = true
  })
}).catch((err)=>{
    dataManager.getProducts().then((products)=>{
    that.products = products
    let buffer = that.products[0].prices.find(price => price.country == "US")
    buffer.zeroPrice = parametersManager.zeroPrice(buffer.price)
    that.actualPrice = buffer
    this.isReady = true
  })
})
        
  }
};

function geoip(geoinfo){
  countryCode = geoinfo.country_code
}
</script>

<style scoped>
.home{
  min-height: 100%;
}
.single-page{
  position: fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
}
.bg{
  position: fixed;
  top:0;
  left:0;
  z-index: 1;
  width:100%;
  height:100%;
}
.bg video{
  width:100%;
  height:100%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  top:0;
  left:0;
}
.content{
  position: fixed;
  top:0;
  left:0;
  z-index: 3;
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.content h1{
  text-align: center;
  font-size: 25px;
  line-height: 32px;
  color:white;
  margin:0;
  margin-top:25px;
}
.fixed-content-wrapper{
  position: fixed;
  bottom:0;
  left:0;
  width:100%;
  z-index: 4;
  padding:0px 0px;
}
.main-button{
  outline: none;
  border:none;
  background:none;
  width:100%;
  height:50px;
  color:white;
  font-weight: bold;
  font-size: 18px;
  line-height: 18px;
  background: rgb(255,66,74);
  background: -moz-linear-gradient(left,  rgba(255,66,74,1) 0%, rgba(255,41,133,1) 100%);
  background: -webkit-linear-gradient(left,  rgba(255,66,74,1) 0%,rgba(255,41,133,1) 100%);
  background: linear-gradient(to right,  rgba(255,66,74,1) 0%,rgba(255,41,133,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff424a', endColorstr='#ff2985',GradientType=1 );
  border-radius: 100px;
  margin:0;
}
.single-page-transition-enter{
  transform: translateX(100%);
}
.single-page-transition-enter-to, .single-page-transition-leave{
  transform: translateX(0%);
}
.single-page-transition-leave-to{
  transform: translateX(-100%);
}
.single-page-transition-enter-active{
  transition: all .15s ease-in;
}
.single-page-transition-leave-active{
  transition: all .15s ease-in;
}
.footer-links{
  width:100%;
  height:35px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer-links button{
  outline: none;
  border:none;
  background:none;
  color:white;
  font-size: 12px;
  line-height: 12px;
  padding: 5px 0px;
  margin:0px
}
.footer-links span{
  color:rgb(140,140,140);
  font-size: 12px;
  line-height: 12px;
  padding: 5px 0px;
  margin:0px 5px;
}
.carousel-wrapper{
  width:100%;
  position: relative;
}
.carousel-slide{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom:0;
  padding:0px 30px;
}
.carousel-slide-holder h2, .carousel-slide h2{
  color:white;
  text-align: center;
  font-size: 25px;
  line-height: 32px;
  margin: 0px;
}
.carousel-slide-holder h3, .carousel-slide h3{
  color:white;
  text-align: center;
  font-size: 20px;
  line-height: 20px;
  margin: 0px;
}
.carousel-slide-holder p, .carousel-slide p{
  color:white;
  text-align: center;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  margin: 0px;
  margin-top:5px;
  margin-bottom: 10px;
}
.carousel-slide-content{
  position: absolute;
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.carousel-slide-content-no-bg{
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.carousel-bg{

}
.carousel-slide-holder{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
  position: relative;
  visibility: hidden;
}
.carousel-slide-holder h2{
  color:white;
  text-align: center;
  font-size: 25px;
  line-height: 32px;
  position: absolute;
  width:100%;
}
.carousel-slide-transition-enter{
  transform: translateX(100%);
}
.carousel-slide-transition-enter-to, .carousel-slide-transition-leave{
  transform: translateX(0%);
}
.carousel-slide-transition-leave-to{
  transform: translateX(-100%);
}
.carousel-slide-transition-enter-active{
  transition: all .3s ease-in;
}
.carousel-slide-transition-leave-active{
  transition: all .3s ease-in;
}

.add-apple-pay-transition-enter{
  opacity: 0;
}
.add-apple-pay-transition-enter-to, .add-apple-pay-transition-leave{
  opacity: 1;
}
.add-apple-pay-transition-leave-to{
  opacity: 0;
}
.add-apple-pay-transition-enter-active{
  transition: all .15s linear;
}
.add-apple-pay-transition-leave-active{
  transition: all .15s linear;
}


.video-transition-enter{
  opacity: 0;
}
.video-transition-enter-to, .video-transition-leave{
  opacity: 1;
}
.video-transition-leave-to{
  opacity: 0;
}
.video-transition-enter-active{
  transition: all .15s linear .20s;
}
.video-transition-leave-active{
  transition: all .15s linear;
}




.appear-transition-enter{
  opacity: 0;
}
.appear-transition-enter-to, .appear-transition-leave{
  opacity: 1;
}
.appear-transition-leave-to{
  opacity: 0;
}
.appear-transition-enter-active{
  transition: all .6s linear 1s;
}
.appear-transition-leave-active{
  transition: all .6s linear;
}


.button-wrapper{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width:100%;
  padding: 0px 30px;
}
.download{
  width:100%;
  text-align: center;
  color:white;
  margin:0;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 25px;
}
.raeting{
  display: flex;
  align-items: center;
  justify-content: center;
  width:100%;
  margin-top:15px;
}
.raeting-person-wrapper{
  width: 100%;
  padding:0px;
}
.raeting-person{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width:100%;
  padding-top:10px;
  border-top:1px solid rgba(255, 255, 255, .2);
}
.raeting span, .raeting-person-info span{
  color:white;
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
}
.raeting img{
  width:105px;
  margin-left:5px;
}
.five-stars{
  width:105px;
}
.raeting-person-info{
  display: flex;
  align-items: center;
  justify-content: center;
}
.raeting-person-info img{
  border-radius: 100px;
  margin-right: 15px;
  width:40px;
}
.overlay{
  position: fixed;
  bottom: 0;
  left:0;
  z-index: 2;
  width:100%;
  background: -moz-linear-gradient(top,  rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%);
  background: -webkit-linear-gradient(top,  rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%);
  background: linear-gradient(to bottom,  rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#000000',GradientType=0 );
}
.overlay img{
  width:100%;
}
.apps-wrapper{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.apps-wrapper img{
  width:40px;
  margin:12px;
  opacity: .4;
  transition:all .3s linear;
}
.apps-wrapper img.active{
  opacity: 1;
}
.price-description{
  font-weight: 600;
  color:white;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
}
.price-info{
  display:flex;
  align-items: center;
  justify-content: center;
}
.price-info span{
  font-weight: 800;
  color:white;
  font-size: 25px;
  line-height: 25px;
}
.price-info .price{
  padding:8px;
  background:rgb(79, 174, 178);
  border-radius: 8px;
}
.r-price-info{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin:0px 0px 10px 0px;
}
.r-price{
  opacity: .4;
  color:white;
  text-align: center;
  font-size: 14px;
  line-height: 14px;
}
.loader{
  width:30px;
  height:30px;
  filter:brightness(2);
  animation: spin 1s linear infinite;
}
.loading-wrapper{
  height:50px;
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
@keyframes spin {
  0%{
    transform: rotate(0deg);
  }
  100%{
    transform: rotate(-359deg);
  }
}
.bg img{
  width:100%;
  height:100%;
  object-fit: cover;
  object-position: center;
}
.download-button{
  outline: none;
  border:none;
  background:none;
  width:225px;
  height:75px;
  border-radius: 15px;
  overflow: hidden;
}
.download-button img{
  width:100%;
  border-radius: 15px;
  overflow: hidden;
}
.spinner-wrapper{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.spinner-wrapper img{
  width:20px;
  height: 20px;
  transition: all .3s linear;
}
.payment-button-wrapper{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-apple-pay-wrapper{
  position: fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  z-index: 9999999;
  background:rgba(0, 0, 0, .8);
  display: flex;
  align-items: center;
  justify-content: center;
  padding:0px 30px;
}
.add-apple-pay-inner{
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
  width:100%;
  background:white;
  padding:30px;
  border-radius: 15px;
}
.add-apple-pay-inner h3{
  text-align: center;
  font-size: 20px;
  line-height: 26px;
  margin-top:18px;
  margin-bottom: 30px;
}
.add-apple-pay-inner img{
  width:155px;
}


@media screen and (width: 320px) {
  .price-description{
    font-size: 10px;
    line-height: 14px;
  }
  .price-info span{
    font-size: 14px;
    line-height: 16px;
    padding:4px;
  }
  .carousel-slide-holder h2, .carousel-slide h2{
    font-size: 20px;
    line-height: 28px;
  }
  .carousel-slide-holder h3, .carousel-slide h3{
    font-size: 18px;
    line-height: 18px;
  }
  .carousel-slide-holder p, .carousel-slide p{
    font-size: 12px;
    line-height: 18px;
  }
  .five-stars{
    width:80px;
  }
  .raeting img{
    width:80px;
  }
  .raeting-person-info span, .raeting span{
    font-size: 14px;
    line-height: 14px;
  }
  .content h1{
    font-size: 16px;
    line-height: 20px;
  }
  .carousel-slide-holder{
    margin-bottom: 20px;
  }
  .r-price{
    font-size: 12px;
    line-height: 12px;
  }
  .footer-links button, .footer-links span{
    font-size: 10px;
  }
}
@media screen and (width: 320px) {
  .icon-wrapper {
    width: 96px;
    height: 96px;
  }
  .app-info-wrapper h1 {
    font-size: 19px;
  }
  .apple-store-wrapper {
    padding: 64px 12px 0px 12px;
  }
  .icon-wrapper {
  }
  .header {
    align-items: stretch;
  }
  .app-info-wrapper .bottom {
    margin-top: 5px;
  }
  .app-info-wrapper {
    padding: 0;
  }
  .swiper-slide {
    border-radius: 6px;
  }
  .gallery-wrapper .swiper-wrapper {
  }
  .gallery-wrapper.vertical {
    width: 400px;
  }
  .header-menu {
    padding: 0px 20px;
  }
  .review-wrapper .content .right .stars .raeting-progress {
    width: 130px;
  }
}

@media screen and (width: 375px) and (-webkit-min-device-pixel-ratio: 2) {
  .header {
    align-items: stretch;
  }
  .app-info-wrapper .bottom {
    margin-top: 5px;
  }
  .app-info-wrapper {
    padding: 0;
  }
  .swiper-slide {
    border-radius: 6px;
  }
  .review-wrapper .content .right .stars .raeting-progress {
    width: 165px;
  }
}

@media screen and (width: 375px) and (-webkit-min-device-pixel-ratio: 3) {
  .five-stars{
    width:80px;
  }
  .raeting img{
    width:80px;
  }
}


@media screen and (width: 414px) {
  .app-info-wrapper .bottom {
    margin-top: 5px;
  }
  .app-info-wrapper {
    padding: 0;
  }
  .swiper-slide {
    border-radius: 6px;
  }
}


@media only screen 
    and (device-width : 375px) 
    and (device-height : 812px) 
    and (-webkit-device-pixel-ratio : 3) {
.swiper-slide video{
  border-radius: 26px;
  overflow: hidden;
}
.swiper-slide {
    border-radius: 26px;
  }
    }

    @media only screen 
    and (device-width : 414px) 
    and (device-height : 896px) 
    and (-webkit-device-pixel-ratio : 2) {
      .swiper-slide video{
  border-radius: 26px;
  overflow: hidden;
}
.swiper-slide {
    border-radius: 26px;
  }
    }

@media only screen 
    and (device-width : 414px) 
    and (device-height : 896px) 
    and (-webkit-device-pixel-ratio : 3) {
  .five-stars{
    width:90px;
  }
  .raeting img{
    width:90px;
  }
}

@media screen and (height:812px) {

}

@media screen and (height:844px) {

}

@media screen and (height:896px) {

}
</style>
<style>
.login-button svg {  
  height: 50px !important;  
  width: 100%;  
} 
.login-button, .login-button *{
  outline: none !important;
}
</style>
